import { randomId } from '@/shared/lib/utils';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkboxId: this.generateRandomId('checkbox-'),
    };
  },
  mounted() {
    if (this.$refs.checkboxInput) {
      this.$refs.checkboxInput.indeterminate = this.indeterminate;
      this.$refs.checkboxInput.disabled = this.disabled;
    }
  },
  mixins: [ randomId ],
  watch: {
    indeterminate: {
      immediate: true,
      handler(newVal) {
        if (this.$refs.checkboxInput) {
          this.$refs.checkboxInput.indeterminate = newVal;
        }
      },
    },
    disabled: {
      handler(newVal) {
        if (this.$refs.checkboxInput) {
          this.$refs.checkboxInput.disabled = newVal;
        }
      }
    },
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (this.disabled) {
          return;
        }

        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    toggle(event) {
      this.checked = event.target.checked;
    }
  }
};
